// This file extends and customizes the preference list coming from LMV.

import { avp } from "@adsk/lmv";
const { Prefs, Prefs3D, Prefs2D } = avp;

// Tandem-added preferences (non-2d/3d).
export const DtPrefsAdded = {
	ENABLE_MODEL_CACHE: 'enableModelCache',
	DISPLAY_OBJECT_INFO: 'objectInfo'
};

export const DtPrefs = {
	...Prefs,
	...DtPrefsAdded
};

// If we ever add any custom 2d/3d preferences, use a prefsAdded object as we do above,
// and use it in DtProfile.apply to add the 2d / 3d tag to our custom prefs.
export const DtPrefs3D = Prefs3D;

// We don't export DtPrefs2D, because we don't use them in Tandem.

// This is used to determine which preferences need to be persisted (see DtProfile).
// The app also uses this to apply preferences stored on the server to viewer preferences.
// Note: We're ignoring 2d preferences here, because we don't use them in Tandem.
export const DtPrefsHelper = {
	prefNames: new Set(Object.values(DtPrefs).concat(Object.values(DtPrefs3D))),

	// The app checks server-side prefs via wildcard?.test(prefName), if the pref is not already found in prefNames.
	wildcard: new RegExp(/^heatmap_/),

	// Preferences that got renamed, changed default value or got deleted.
	// A null value means that the preference is no longer used and should be deleted if cached.
	// Entries have the format <oldName>: null | { newName: <name>, newDefault: <value> }
	// where newName and newDefault are optional, but at least one has to be provided.
	// If newName is not given, the old name will be preserved, while newDefault will be picked up
	// from the profile (via newName) if not provided.
	migrations: {
		// TODO: Remove after some migration time.
		// The name of the WebGPU preference is different in LMV.
		'webgpuEnable': { newName: DtPrefs.WEBGPU },

		// TODO: Remove after some migration time.
		// Old preferences that don't exist anymore.
		'disableIndexedDb': null,
		'enableFragmentCache': null,
		'firstPersonToolPopup': null
	}
};

// TODO: Remove after some migration time.
// Also add migrations for all 2d prefs, because we don't use them anymore.
for (const key of Object.values(Prefs2D)) {
	DtPrefsHelper.migrations[key] = null;
}
